/**
 * Stable, per-browser device identifier used by the Device Trust system
 * (Feb 2026). Generated once on first load and persisted in
 * ``localStorage``. Backend accepts it via the ``X-Device-Id`` header
 * and either trusts or challenges the caller.
 *
 * We intentionally do NOT try to derive a MAC address or hardware
 * fingerprint — browsers can't read them and any such heuristic breaks
 * cross-browser (e.g. an operator switching from Chrome to Firefox on
 * the same tablet). The UUID is stable per (browser × profile) which
 * is exactly the granularity the manager wants to control.
 */
const KEY = "pontepos_device_id";

function _uuid() {
  try {
    if (typeof crypto !== "undefined" && crypto.randomUUID) {
      return crypto.randomUUID();
    }
  } catch {
    /* fall through */
  }
  // RFC-4122-ish v4 fallback for older browsers.
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export function getDeviceId() {
  try {
    let id = localStorage.getItem(KEY);
    if (!id) {
      id = _uuid();
      localStorage.setItem(KEY, id);
    }
    return id;
  } catch {
    // Private-mode / storage disabled — return an ephemeral ID for the
    // duration of this tab so the backend still gets a header.
    if (!window.__ponte_ephemeral_device_id)
      window.__ponte_ephemeral_device_id = _uuid();
    return window.__ponte_ephemeral_device_id;
  }
}

export function clearDeviceId() {
  try { localStorage.removeItem(KEY); } catch { /* ignore */ }
}
